/**
 * Coid 2.0 server
 * Coid 2.0 server API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum OrganizationType {
    BANK = 'BANK',
    EXCHANGE = 'EXCHANGE',
    INS = 'INS',
    PENSION = 'PENSION',
    SECURITY = 'SECURITY',
    NOTARY = 'NOTARY',
    LEGAL = 'LEGAL',
    ACCOUNTING = 'ACCOUNTING',
    GAMBLING = 'GAMBLING',
    POST = 'POST',
    MFO = 'MFO',
    PAYM = 'PAYM',
    PAYM_1 = 'PAYM_1',
    LEASING = 'LEASING',
    PRECIOUS = 'PRECIOUS',
    REAL_ESTATE = 'REAL_ESTATE',
    MED_INSURANCE = 'MED_INSURANCE',
    AIFC = 'AIFC',
    REG = 'REG',
    GOV = 'GOV',
    COLLECTOR = 'COLLECTOR',
    CREDIT_BUREAU = 'CREDIT_BUREAU',
    ECOM = 'ECOM',
    OTHER = 'OTHER'
}

